<template>
  <div class="app" id="app" ref="app">
    <intro v-if="introVal === 'start'" />
    <transition name="fade">
      <router-view v-if="introVal === 'end'" />
    </transition>
    <start-project-pop />
    <recruit-pop />
    <pds-pop />
    <awards-pop />
    <culture-pop />
    <lnb-area v-if="['logo', 'end'].includes(introVal)" />
    <rnb-area />
    <loading />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Intro from "@/components/Intro";
import lnbArea from "@/components/LNB";
import rnbArea from "@/components/RNB";
import startProjectPop from "@/components/StartProjectPop";
import recruitPop from "@/components/RecruitPop";
import pdsPop from "@/components/PdsPop";
import awardsPop from "@/components/AwardsPop";
import culturePop from "@/components/CulturePop";
import loading from "@/components/Loading";
export default {
  name: "App",
  data() {
    return {
      introData: ""
    };
  },
  components: {
    Intro,
    lnbArea,
    rnbArea,
    startProjectPop,
    awardsPop,
    recruitPop,
    pdsPop,
    culturePop,
    loading
  },
  computed: {
    ...mapState("common", {
      introVal: state => state.introVal
      //loading: state => state.loading
    })
  },
  methods: {
    ...mapActions("common", {
      setIntroAction: "setIntro",
      setReadyAction: "setReadyAction"
    })
  },
  mounted() {
    // if (this.$route.name === 'main' && Boolean(Vue.$cookies.get('intro')) === false) {
    //   this.setIntroAction('start')
    // } else {
    this.setIntroAction("end");
    this.setReadyAction(true);
    // }
  },
  created() {
    
  }
};
</script>

<style></style>
